import Button from '@/components/NextUI/Button';
import TextArea from '@/components/NextUI/TextArea';
import { CancellationReasons } from '@/features/subscription/enum/cancellationReasons';
import { CancellationSteps } from '@/features/subscription/enum/cancellationSteps';
import { Radio, RadioGroup } from '@heroui/radio';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

export const ReasonStep = ({
  isSubmitting,
  reason,
  setReason,
  otherText,
  setOtherText,
  setStep,
  onContinue,
}: {
  isSubmitting: boolean;
  reason: string;
  setReason: React.Dispatch<React.SetStateAction<string>>;
  otherText: string;
  setOtherText: React.Dispatch<React.SetStateAction<string>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  onContinue: () => void;
}) => {
  const t = useTranslations('modals.cancel_subscription.steps.reason');
  const translatedReasons = Object.values(CancellationReasons).map(
    (reason) => ({
      value: reason,
      label: t(`reasons.${reason}`),
    })
  );
  return (
    <>
      <div>
        <span className="text-xl font-semibold text-dark">{t('title')}</span>
        <p className="text-gray-medium text-[17px] mt-6">{t('description')}</p>
      </div>
      <div className="mt-6">
        <RadioGroup value={reason} onValueChange={setReason}>
          {translatedReasons.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </RadioGroup>
      </div>
      {reason === CancellationReasons.OTHER && (
        <div className="mt-6">
          <TextArea
            value={otherText}
            onValueChange={setOtherText}
            placeholder={t('other_placeholder')}
            minRows={4}
            className="w-full"
            disabled={isSubmitting}
          />
        </div>
      )}
      <div className="flex justify-end gap-4 mt-12 w-full">
        <Button
          variant="outline"
          onClick={() => setStep(CancellationSteps.Goodbye)}
        >
          {t('buttons.back')}
        </Button>
        <Button
          color="primary"
          className={clsx({
            'text-white data-[hover=true]:text-white !bg-gray-lighter cursor-not-allowed':
              !reason || (reason === CancellationReasons.OTHER && !otherText),
          })}
          onClick={() => {
            if (reason === CancellationReasons.OTHER && !otherText) return;
            onContinue();
          }}
          disabled={
            !reason || (reason === CancellationReasons.OTHER && !otherText)
          }
        >
          {t('buttons.continue')}
        </Button>
      </div>
    </>
  );
};
